@for (file of getFilesById(); track $index) {
  <app-file-card
    [fileCard]="{
      id: file.id,
      fileParams: file.file,
      fileType: 'PRODUCT_PACKAGE',
      isEditModeActive: isEditModeActive(),
      shouldCheckImageType: false
    }"
    (handleDelete)="handleDelete($event, file)"
  />
}
<app-file-upload-card
  [fileUploadParams]="{
    parentId: productPackageId(),
    recordId: productPackageId(),
    type: `PRODUCT_PACKAGE-${productPackageId()}`,
    entityFileType: 'PRODUCT_PACKAGE'
  }"
  [isEditModeActive]="isEditModeActive()"
  (attachFile)="attachFile($event)"
/>
